module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10042.36f21ddf.jpg";